/**
 * ScoreRangeFilter Component
 * 
 * Radio button group for filtering matches by score ranges.
 * Provides options: All, Below 60%, 60-70%, 70-80%, 80-90%, 90-100%
 */

import React from 'react';
import type { ScoreRange } from '../../utils/matchFilters';
import { SCORE_RANGES } from '../../utils/matchFilters';

interface ScoreRangeFilterProps {
  selectedRange: ScoreRange;
  onChange: (range: ScoreRange) => void;
}

const ScoreRangeFilter: React.FC<ScoreRangeFilterProps> = ({
  selectedRange,
  onChange
}) => {
  const ranges: Array<{ value: ScoreRange; label: string }> = [
    { value: 'all', label: SCORE_RANGES.all.label },
    { value: 'below60', label: SCORE_RANGES.below60.label },
    { value: '60-70', label: SCORE_RANGES['60-70'].label },
    { value: '70-80', label: SCORE_RANGES['70-80'].label },
    { value: '80-90', label: SCORE_RANGES['80-90'].label },
    { value: '90-100', label: SCORE_RANGES['90-100'].label }
  ];

  return (
    <div className="space-y-1.5">
      <label className="text-xs font-medium text-gray-700">
        Match Score Range:
      </label>
      <div className="flex flex-wrap gap-3">
        {ranges.map((range) => (
          <label
            key={range.value}
            className="flex items-center space-x-1.5 cursor-pointer"
          >
            <input
              type="radio"
              name="score-range"
              value={range.value}
              checked={selectedRange === range.value}
              onChange={() => onChange(range.value)}
              className="w-3.5 h-3.5 text-blue-600 border-gray-300 focus:ring-blue-500 focus:ring-2 cursor-pointer"
              aria-label={`Filter by ${range.label} score range`}
            />
            <span className="text-xs text-gray-700">{range.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default ScoreRangeFilter;
